import * as types from '../mutation-types'
import Vue from 'vue'
import partners from '@/api/partners'

const state = {
  partners: [],
  partnerPageInfo: {}
}

const getters = {
  partners: (state) => {
    return state.partners
  },
  partnerPageInfo: (state) => {
    return state.partnerPageInfo
  }
}

const actions = {
  getPartners ({ commit }) {
    commit(types.CLEAR_PARTNERS)
    return new Promise((resolve, reject) => {
      partners.getPartners().then((response) => {
        const { partners } = response.data

        partners.forEach((partner) => {
          commit(types.ADD_PARTNER, partner)
        })
        resolve(partners)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPartnerPageInfo ({ commit }, { partnerId }) {
    return new Promise((resolve, reject) => {
      partners.getPartnerPageInfo(partnerId).then(response => {
        const { info } = response.data

        commit(types.ADD_PARTNER_PAGE_INFO, { partnerId, info })
        resolve(info)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.CLEAR_PARTNERS] (state) {
    state.partners = []
  },
  [types.ADD_PARTNER] (state, partner) {
    Vue.set(state.partners, partner.id - 1, partner)
  },
  [types.ADD_PARTNER_PAGE_INFO] (state, params) {
    Vue.set(state.partnerPageInfo, params.partnerId, params.info)
  },
  [types.UPDATE_PARTNER_PAGE_INFO] (state, params) {
    const index = state.partnerPageInfo[params.partnerId].findIndex(info => info.name === params.info.name)
    if (index === -1) {
      state.partnerPageInfo[params.partnerId].push(params.info)
    } else {
      state.partnerPageInfo[params.partnerId][index] = params.info
      Vue.set(state.partnerPageInfo, params.info, state.partnerPageInfo[params.partnerId])
    }
  },
  [types.DELETE_PARTNER_PAGE_INFO] (state, { partnerId, index }) {
    state.partnerPageInfo[partnerId].splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
